import { useMemo } from "react";
import { useGetSiteQuery } from "features/site/siteApi";
import {
  getBootstrapSiteConfig,
  hasEnvBranding,
  mergeSiteConfig,
  resolveLogoUrl,
} from "config/siteBranding";

export const useSite = () => {
  const { data, isLoading, isFetching, isSuccess } = useGetSiteQuery();

  const config = useMemo(() => (data ? data : mergeSiteConfig({})), [data]);

  const bootstrap = useMemo(() => getBootstrapSiteConfig(), []);
  const hasEnv = hasEnvBranding();
  const isSiteLoaded = isSuccess || hasEnv;
  const isSiteLoading = (isLoading || isFetching) && !isSiteLoaded;

  const logo = resolveLogoUrl(config.logo || bootstrap.logo);
  const frontWalletSecondaryLogo = resolveLogoUrl(
    config.frontWalletSecondaryLogo || bootstrap.frontWalletSecondaryLogo
  );
  const favicon = config.favicon ? resolveLogoUrl(config.favicon) : "";

  const isLogoLoading = isSiteLoading && !logo && !bootstrap.logo;

  return {
    logo,
    siteMainEmail: config.siteMainEmail,
    privacyAndPolicyUrl: config.privacyAndPolicyUrl,
    termsAndConditionsUrl: config.termsAndConditionsUrl,
    frontWalletAuthPageColor: config.frontWalletAuthPageColor,
    frontWalletSecondaryLogo,
    registrationType: config.registrationType,
    favicon,
    btcManualSellAddress: config.btcManualSellAddress,
    ethErc20ManualSellAddress: config.ethErc20ManualSellAddress,
    trxTrc20ManualSellAddress: config.trxTrc20ManualSellAddress,
    multilanguage: config.multilanguage,
    multiCompanyMode: config.multiCompanyMode,
    strongPasswordEnabled: config.strongPasswordEnabled,
    optionalTwofa: config.optionalTwofa,
    isSiteLoaded,
    isSiteLoading,
    isLogoLoading,
  };
};
